import { mapActions } from 'vuex'

export default {
  data: () => ({
    crCancelLoading: false,
  }),
  methods: {
    ...mapActions(['sendCRClose', 'reportError']),
    async crClose () {
      try {
        this.crCancelLoading = true

        const response = await this.sendCRClose()

        this.crCancelLoading = false

        return response
      } catch (e) {
        this.reportError(e)
      }
    }
  },
}
